export class EmailVerificationParameters {
    public expirationTimeInMinutes: number;
    public codeLength: number;
}